import { IMakeRequest } from '../../utils/make_request';
import { filterServerResponse } from '../helpers';
import { IServerError } from '../types';

import type { IHTTPRequestConfig } from '@cian/http-api';

export interface ISuccessResponse {
  status: 'ok';
}

export function sendReclaim(
  makeRequest: IMakeRequest,
  host: string,
  realtyOfferId: number,
): Promise<ISuccessResponse | IServerError> {
  return makeRequest({
    body: `realty_id=${realtyOfferId}`,
    headers: [['Content-Type', 'application/x-www-form-urlencoded']],
    method: 'POST',
    uri: {
      host,
      path: '/ajax/fix/',
      scheme: document.location.protocol.slice(0, -1) as IHTTPRequestConfig['uri']['scheme'],
    },
  })
    .then(filterServerResponse)
    .then(response => JSON.parse(response.responseBody));
}
